import { BaseTooltip, type BaseTooltipTriggerProps } from "./base-tooltip";

export const PromptTypeTooltip = ({ trigger, triggerClassName }: BaseTooltipTriggerProps = {}) => {
      return (
            <BaseTooltip trigger={trigger} triggerClassName={triggerClassName}>
                  <div className="flex flex-col gap-1">
                        <p className="font-bold">Organic</p>
                        <p>
                              Aims to reproduce the natural discovery process of a user. <br />
                              Rigorously does not mention the brand name.
                        </p>
                        <p className="font-bold">Competitor</p>
                        <p>Compares the brand with its competitors.</p>
                        <p className="font-bold">Brand Specific</p>
                        <p>Focuses on the brand itself and the way it is perceived.</p>
                  </div>
            </BaseTooltip>
      );
};
